import ConfirmUserModal from './ConfirmUserModal';

export default ConfirmUserModal;
